<ion-content fullscreen="true" class="transparent-modal">
  <ion-grid class="grid-box-container">
    <ion-row>
      <ion-col size="2" class="ion-text-center">
        <ion-button (click)="close()" fill="clear" color="light"
          style="--ripple-color: transparent; --background-hover: transparent">
          <ion-icon name="close" slot="icon-only"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>

  <swiper-container init="false" #swiperEl class="swiper-box-container">
    @for (urlFoto of imagesURLs(); track urlFoto) {
    <swiper-slide>
      <div class="swiper-zoom-container">
        <img [src]="urlFoto" alt="Imagen de daños o grafica del slider" class="box-clickable"
          [ngClass]="{'charts-dimensions': chartSlider(),'normal-dimensions': !chartSlider(),}"
          (click)="openPreviewImage(urlFoto)" draggable="false" />
      </div>
    </swiper-slide>
    }
  </swiper-container>
</ion-content>